/* tslint:disable */
/* eslint-disable */
/**
 * DEX API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime'
import {
  AffiliatePackageInfo,
  AffiliatePackageInfoFromJSON,
  AffiliatePackageInfoToJSON,
  CashbackPoolResponse,
  CashbackPoolResponseFromJSON,
  CashbackPoolResponseToJSON,
  FeesResponse,
  FeesResponseFromJSON,
  FeesResponseToJSON,
  TvlResponse,
  TvlResponseFromJSON,
  TvlResponseToJSON,
} from '../models'

/**
 *
 */
export class InfoApi extends runtime.BaseAPI {
  /**
   */
  async getCashbackPoolRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<CashbackPoolResponse>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/api/cashback/pool`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse(response, (jsonValue) => CashbackPoolResponseFromJSON(jsonValue))
  }

  /**
   */
  async getCashbackPool(initOverrides?: RequestInit): Promise<CashbackPoolResponse> {
    const response = await this.getCashbackPoolRaw(initOverrides)
    return await response.value()
  }

  /**
   */
  async getFarmingLevelsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<AffiliatePackageInfo>>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/api/referral-program/farming-levels`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AffiliatePackageInfoFromJSON))
  }

  /**
   */
  async getFarmingLevels(initOverrides?: RequestInit): Promise<Array<AffiliatePackageInfo>> {
    const response = await this.getFarmingLevelsRaw(initOverrides)
    return await response.value()
  }

  /**
   */
  async getFeesRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<FeesResponse>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/api/fees`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse(response, (jsonValue) => FeesResponseFromJSON(jsonValue))
  }

  /**
   */
  async getFees(initOverrides?: RequestInit): Promise<FeesResponse> {
    const response = await this.getFeesRaw(initOverrides)
    return await response.value()
  }

  /**
   */
  async getInfoRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<TvlResponse>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/api/info`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse(response, (jsonValue) => TvlResponseFromJSON(jsonValue))
  }

  /**
   */
  async getInfo(initOverrides?: RequestInit): Promise<TvlResponse> {
    const response = await this.getInfoRaw(initOverrides)
    return await response.value()
  }

  /**
   */
  async getNmxPriceRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<number>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/api/info/nmx-price`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    )

    return new runtime.TextApiResponse(response) as any
  }

  /**
   */
  async getNmxPrice(initOverrides?: RequestInit): Promise<number> {
    const response = await this.getNmxPriceRaw(initOverrides)
    return await response.value()
  }
}
